module.exports = __webpack_public_path__ + "assets/img/32_561_big.a7bc8423.jpg";